<template>
  <div id="original-expansion-panel">
    <v-expansion-panels v-model="openPanelIndex" :disabled="disabled" multiple>
      <v-expansion-panel class="rounded-lg">
        <v-flex class="d-flex align-center">
          <slot name="header" />
          <v-spacer> </v-spacer>
          <span v-if="isUpDown" class="mx-3">
            <UpDownChevron @click.native="panelOpen" :flg="open" />
          </span>
        </v-flex>
        <v-divider> </v-divider>
        <!-- 
<v-expansion-panel-header>          
<slot name="header" />        
</v-expansion-panel-header> -->
        <v-expansion-panel-content>
          <slot name="content" />
        </v-expansion-panel-content>
        <div v-if="isFooter">
          <v-divider> </v-divider>
          <slot name="footer" />
        </div>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import UpDownChevron from '@/components/items/Buttons/UpDownChevron'

export default {
  components: {
    UpDownChevron
  },
  props: {
    open: { default: false },
    isFooter: { default: false },
    isUpDown: { default: true }
  },
  data: () => {
    return {
      openPanelIndex: [],
      disabled: false,
      readonly: false
    }
  },
  created() {
    this.openPanelIndex = this.open ? [0] : []
  },
  watch: {
    open: function (newVal) {
      this.openPanelIndex = newVal ? [0] : []
    },
    openPanelIndex: function (newVal) {
      this.$emit('change', newVal)
    }
  },
  methods: {
    panelOpen() {
      this.openPanelIndex = this.openPanelIndex.length ? [] : [0]
    }
  }
}
</script>
<style lang="scss" scoped>
#original-expansion-panel::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
